<div class="flex flex-column h-full">
  <div class="flex flex-column gap-2">
    <div *ngFor="let module of modules" class="field-checkbox">
      <p-checkbox [(ngModel)]="selectedModules" [inputId]="'module-' + module.id" name="group" [value]="module"></p-checkbox>
      <label [for]="'module-' + module.id">{{ module.description }}</label>
    </div>
  </div>
  <div class="flex align-items-end flex-grow-1 justify-content-end">
    <p-button (onClick)="setModules()" label="Enregistrer" icon="pi pi-check" iconPos="right"></p-button>
  </div>
</div>

